import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=226bb4ea&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=226bb4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bb4ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226bb4ea')) {
      api.createRecord('226bb4ea', component.options)
    } else {
      api.reload('226bb4ea', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=226bb4ea&scoped=true&", function () {
      api.rerender('226bb4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4VmCIFTXbWP4C/JS/comp/Voucher.vue"
export default component.exports